import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Permission } from '@core/config/permissions.config';
import { PermissionService } from '@core/services/permission.service';
import { WorkspaceService } from '@core/services/workspace.service';

/**
 * Generic, role-agnostic route guard. Reads `data.permission` from the route and
 * defers to the permission service. Routes never name roles directly.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const perms = inject(PermissionService);
  const ws = inject(WorkspaceService);
  const router = inject(Router);

  const required = route.data['permission'] as Permission | undefined;
  if (!required || perms.can(required)) return true;

  return router.createUrlTree([ws.homeRoute()]);
};
